<div class='card'>
    <div class='p-2' style="height: 48px;" *ngIf="loading">
        <ngx-sync-loader></ngx-sync-loader>
    </div>
    <app-menu-dropdown-nav-bar *ngIf="!loading" [modules]="modules" [mobileWidth]="'80vw'"></app-menu-dropdown-nav-bar>
</div>